import { Button } from '@gif/shared-ui';
import { Dropdown, light } from '@mlb/play-ui';
import styled from 'styled-components';

export const AdditionalInformationContainer = styled.section`
  font-weight: 300;
  color: ${light.legalTextColor};
`;

export const RequiredText = styled.p`
  margin-bottom: 1rem;
  text-align: center;
  font-size: 0.875rem;
`;

export const CountryOfResidenceSection = styled.div`
  margin-bottom: 2rem;
`;

export const TermsContainer = styled.p`
  text-align: center;
  font-size: 0.875rem;
  margin: 0.5rem 0 0 0;
  font-weight: 500;

  a {
    text-decoration: none;
    &:link,
    &:visited,
    &:active {
      color: ${(props) => props.theme.linkColor};
    }
  }
`;

export const InformationSection = styled.section`
  text-align: center;
  color: ${light.legalTextColor};
  font-weight: 300;
  font-size: 0.875rem;
  p {
    margin: 0;
  }
`;

export const StyledButton = styled(Button)`
  margin: 1rem auto;
  height: 2.75rem;
  min-width: 13.75rem;
  &:focus-visible,
  button:focus-visible {
    outline: revert;
    border: white solid 0.25rem;
  }
`;

export const ProvinceDropdown = styled(Dropdown)`
  margin-top: 1rem;
`;
